export enum LangType {
  UA = "UA",
  EN = "EN",
}

const translations = {
  EN: {
    about: "About me",
    content: "Stories",
    projects: "Pet-projects",
    exhibition: "Exhibition",
    contacts: "Contacts",
    aboutMe: `My creativity manifests in various forms — I capture the vibrant moments of life through photography, create light and atmospheric watercolors, write stories, or write code to bring my new ideas to life.\nEach part of my life adds depth and color to my personality.\nI am constantly learning, growing, and embracing new challenges, combining my technical skills with artistic ones to live life to the fullest.\nThank you for visiting!`,
    author: "Yuliia Sugak",
    contactsText: "Please contact me via email - jujuvorona@gmail.com",
    contentTitle: "Content",
    experiments: "Experiments",
    heartFilled: false,
    motivatorTitle: "Motivator",
    motivatorDesc: "Fun extension that supports you in everyday work",
    studioTitle: "YouTube Channel – Songs for Kids",
    studioDesc:
      "YouTube channel with fun and educational songs for kids. I create songs and animations with AI, using my original poems for lyrics and story.",
    cvTitle: "My cool CV",
    cvDesc: "Free WYSIWYG app for creating CVs",
    etsyTitle: "First July Studio (Etsy)",
    etsyDesc:
      "Etsy shop with digital prints of my original watercolor paintings.",
    exhibitionTitle: "Exhibition Albums",
    // Add more keys as needed
  },
  UA: {
    about: "Про мене",
    content: "Оповідання",
    projects: "Pet-проекти",
    exhibition: "Виставка",
    contacts: "Контакти",
    aboutMe: `Моя творчість проявляється у різних формах - я ловлю яскраві моменти життя через фотографію, створюю легкі та атмосферні акварелі, пишу оповідання, чи пишу код та втілюю свої нові ідеї.\nКожна частина мого життя додає глибини та кольору моїй особистості. Я постійно вчуся, зростаю і приймаю нові виклики, поєднуючи свої технічні навички з мистецькими, щоб жити наповну.\nДякую, що завітали!`,
    author: "Юлія Сугак",
    contactsText: "Моя пошта для зворотнього зв'язку - jujuvorona@gmail.com",
    contentTitle: "Зміст",
    experiments: "Експерименти",
    heartFilled: true,
    motivatorTitle: "Motivator",
    motivatorDesc: "Fun extension that supports you in everyday work",
    studioTitle: "Творча студія - Гармидейра",
    studioDesc:
      "YouTube channel with fun and educational songs for kids. I create songs and animations with AI, using my original poems for lyrics and story.",
    cvTitle: "My cool CV",
    cvDesc: "Free WYSIWYG app for creating CVs",
    etsyTitle: "First July Studio (Etsy)",
    etsyDesc:
      "Магазин Etsy з цифровими принтами моїх оригінальних акварельних картин.",
    exhibitionTitle: "Альбоми виставки",
    // Add more keys as needed
  },
};

export function useTranslation(lang: LangType) {
  return (key: keyof (typeof translations)["UA"]) => translations[lang][key];
}

export type TranslationKey = keyof (typeof translations)[LangType.UA];
